import {KTIcon} from '../../../_metronic/helpers'
import {MediaViewer} from '../../utils/components/MediaViewer'
import TableContent from '../../utils/components/table-content/TableContent'
import {ICustomerLedgerResponse} from './_model'
import CustomBottomRow from './CustomBottomRow'
import ledgerColumn from './ledgerColumn'

type Props = {
  content: ICustomerLedgerResponse | null
}

const LedgerContent = ({content}: Props) => {
  if (!content) return null

  const ledgers = content.ledgerDetails.slice(0, -1)
  const totalContent = content.ledgerDetails[content.ledgerDetails.length - 1]

  return (
    <div className='mt-12'>
      <div className='d-flex align-items-center gap-8 mb-10'>
        <MediaViewer
          media={content?.userDetails.user_img}
          classname='w-80px h-80px overflow-hidden rounded'
        />

        <div>
          <h3>{content.userDetails.user_full_name}</h3>
          <div className='d-flex gap-5'>
            <div className='d-flex align-items-center gap-2'>
              <KTIcon iconName='send' className='fs-2 text-primary' />
              <p className='m-0 fs-6'>{content.userDetails.userEmail}</p>
            </div>
            <div className='d-flex align-items-center gap-2'>
              <KTIcon iconName='phone' className='fs-2 text-primary' />
              <p className='m-0 fs-6'>{content.userDetails.userMobile}</p>
            </div>
          </div>
          <p className='badge badge-light-success mt-2 fs-6'>
            {content.userDetails.payment_type === '0' ? 'Prepaid' : 'Postpaid'}
          </p>
        </div>
      </div>

      <TableContent
        isLoading={!!content}
        tableData={ledgers}
        tableColumn={ledgerColumn}
        bottomRows={<CustomBottomRow totalContent={totalContent} />}
      />
    </div>
  )
}

export default LedgerContent
